import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type DemoRequestCtaProps = CtaShellProps

export function DemoRequestCta(props: DemoRequestCtaProps) {
  return <CtaShell {...props} layout="split-form" actionType="demo" form={props.form ?? { fields: [
    { name: "name", label: "Name", required: true },
    { name: "email", label: "Work email", type: "email", required: true },
    { name: "company", label: "Company", type: "company" },
  ], submitLabel: "Request demo", successMessage: "Demo request received." }} />
}
